<template>
    <div class="weapons-display mt-3">
        <div class="d-flex justify-content-between align-items-center mb-2">
            <h4 class="mb-0">Weapons</h4>
            <button
                type="button"
                class="btn btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#weaponsModal"
            >
                <font-awesome-icon icon="plus" class="me-1" />Add
            </button>
        </div>

        <hr />

        <div class="row">
            <div
                class="col-sm-12 mb-3"
                v-for="(weapon, index) in character.weapons"
                v-bind:key="weapon.name"
            >
                <div class="d-flex justify-content-between align-items-center">
                    <strong
                        @click="selectedWeapon = weapon.name"
                        data-bs-toggle="modal"
                        data-bs-target="#weaponModal"
                        cursor="pointer"
                        >{{ weapon.name || "Unnamed Weapon" }}</strong
                    >
                    <div class="d-flex justify-content-end">
                        <div
                            v-for="archetype in weapon.archetype"
                            :key="archetype"
                        >
                            <img
                                :src="
                                    getIconSrc(
                                        archetype + rosterStore.theme + '.png'
                                    )
                                "
                                :alt="archetype"
                                style="max-width: 2rem; margin-left: 0.5rem"
                                @click="requestDiceBox(archetype)"
                                cursor="pointer"
                            />
                        </div>
                    </div>
                </div>
                <hr v-if="index < character.weapons.length - 1" />
            </div>
        </div>
    </div>

    <!-- Modal to add a weapon -->
    <div
        class="modal fade"
        id="weaponsModal"
        tabindex="-1"
        aria-labelledby="weaponsModalLabel"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content bg-dark text-light rounded-3 shadow-lg">
                <div class="modal-header">
                    <h4 class="modal-title" id="weaponsModalLabel">
                        Add Weapon
                    </h4>
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    ></button>
                </div>
                <div class="modal-body">
                    <!-- Nav tabs -->
                    <ul class="nav nav-tabs mb-3" role="tablist">
                        <li class="nav-item">
                            <button
                                class="nav-link active"
                                data-bs-toggle="tab"
                                data-bs-target="#premadeTab"
                                type="button"
                                role="tab"
                                @click="activeTab = 'premade'"
                            >
                                Premade
                            </button>
                        </li>
                        <li class="nav-item">
                            <button
                                class="nav-link"
                                data-bs-toggle="tab"
                                data-bs-target="#customTab"
                                type="button"
                                role="tab"
                                @click="activeTab = 'custom'"
                            >
                                Custom
                            </button>
                        </li>
                    </ul>

                    <div class="tab-content">
                        <!-- Premade Tab -->
                        <div
                            class="tab-pane fade show active"
                            id="premadeTab"
                            role="tabpanel"
                        >
                            <div class="input-group mb-3">
                                <span class="input-group-text" id="weapon-type"
                                    >Premade Weapon</span
                                >
                                <select
                                    class="form-select"
                                    aria-describedby="weapon-type"
                                    v-model="selectedWeapon"
                                    @change="fillFromPreset"
                                >
                                    <option value="">Select...</option>
                                    <optgroup
                                        v-for="[
                                            type,
                                            weapons,
                                        ] in groupedWeapons"
                                        :key="type"
                                        :label="type"
                                    >
                                        <option
                                            v-for="weapon in weapons"
                                            :key="weapon.name"
                                            :value="weapon.name"
                                        >
                                            {{ weapon.name }}
                                            ({{
                                                weapon.archetype
                                                    .map(
                                                        (a) =>
                                                            a
                                                                .charAt(0)
                                                                .toUpperCase() +
                                                            a.slice(1)
                                                    )
                                                    .join(", ")
                                            }})
                                        </option>
                                    </optgroup>
                                </select>
                            </div>

                            <div v-if="selectedWeapon">
                                <h5>
                                    <strong>{{ newWeapon.name }}</strong>
                                </h5>
                                <p>{{ newWeapon.description }}</p>

                                <p>
                                    <strong>Damage:</strong>
                                    {{ newWeapon.damage }}
                                    {{ newWeapon.damageType }}
                                </p>

                                <p>
                                    <strong>Range:</strong>
                                    {{ newWeapon.range }}
                                </p>

                                <div v-if="newWeapon.abilities.length">
                                    <strong>Abilities:</strong>
                                    <ul>
                                        <li
                                            v-for="(
                                                ab, i
                                            ) in newWeapon.abilities"
                                            :key="i"
                                        >
                                            <strong>{{ ab.name }}</strong
                                            >: {{ ab.description }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <!-- Custom Tab -->
                        <div
                            class="tab-pane fade"
                            id="customTab"
                            role="tabpanel"
                        >
                            <div class="input-group mb-3">
                                <span class="input-group-text">Name</span>
                                <input
                                    v-model="newWeapon.name"
                                    type="text"
                                    class="form-control"
                                />
                            </div>

                            <div class="input-group mb-3">
                                <span class="input-group-text"
                                    >Description</span
                                >
                                <textarea
                                    v-model="newWeapon.description"
                                    class="form-control"
                                ></textarea>
                            </div>

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="input-group mb-3">
                                        <span class="input-group-text"
                                            >Skill Type</span
                                        >
                                        <select
                                            v-model="selectedArchetype"
                                            class="form-select"
                                        >
                                            <option disabled value="">
                                                Select...
                                            </option>
                                            <option value="grit">Grit</option>
                                            <option value="wit">Wit</option>
                                            <option value="smarts">
                                                Smarts
                                            </option>
                                            <option value="heart">Heart</option>
                                            <option value="luck">Luck</option>
                                            <option value="strange">
                                                Strange
                                            </option>
                                        </select>
                                        <button
                                            class="btn btn-outline-primary"
                                            type="button"
                                            @click="addArchetype"
                                        >
                                            Add
                                        </button>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input-group mb-3">
                                        <span class="input-group-text"
                                            >Range</span
                                        >
                                        <select
                                            v-model="newWeapon.range"
                                            class="form-select"
                                        >
                                            <option disabled value="">
                                                Select...
                                            </option>
                                            <option value="Close (5ft)">
                                                Close (5ft)
                                            </option>
                                            <option value="Near (15ft)">
                                                Near (15ft)
                                            </option>
                                            <option value="Medium (50ft)">
                                                Medium (50ft)
                                            </option>
                                            <option value="Long (150ft)">
                                                Long (150ft)
                                            </option>
                                            <option value="Far (200ft)">
                                                Far (200ft)
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="input-group mb-3">
                                <span class="input-group-text">Damage</span>
                                <select
                                    v-model="newWeapon.damage"
                                    class="form-select"
                                >
                                    <option disabled value="">Select...</option>
                                    <option v-for="n in 10" :key="n" :value="n">
                                        {{ n }}
                                    </option>
                                </select>
                                <span class="input-group-text">Type</span>
                                <input
                                    v-model="newWeapon.damageType"
                                    type="text"
                                    class="form-control"
                                />
                            </div>

                            <!-- Abilities -->
                            <div class="input-group mb-3">
                                <span class="input-group-text">Abilities</span>
                                <select
                                    v-model="selectedAbility"
                                    class="form-select"
                                >
                                    <option disabled value="">Select...</option>
                                    <option
                                        v-for="ability in rosterStore.weaponAbilities.sort(
                                            (a, b) =>
                                                a.name.localeCompare(b.name)
                                        )"
                                        :key="ability.name"
                                        :value="ability.name"
                                    >
                                        {{ ability.name }}
                                    </option>
                                </select>
                                <button
                                    class="btn btn-outline-primary"
                                    type="button"
                                    @click="addAbility"
                                >
                                    Add
                                </button>
                            </div>

                            <div class="input-group mb-3">
                                <span class="input-group-text"
                                    >Custom Ability</span
                                >
                                <input
                                    v-model="customAbilityName"
                                    type="text"
                                    class="form-control"
                                    placeholder="Name"
                                />
                                <input
                                    v-model="customAbilityDesc"
                                    type="text"
                                    class="form-control"
                                    placeholder="Description"
                                />
                                <button
                                    class="btn btn-outline-primary"
                                    type="button"
                                    @click="addCustomAbility"
                                >
                                    Add
                                </button>
                            </div>

                            <!-- Show selected skill types -->
                            <div v-if="newWeapon.archetype.length" class="mb-3">
                                <strong>Selected Skill Types:</strong>
                                <div class="d-flex flex-wrap gap-2 mt-2">
                                    <span
                                        v-for="(a, i) in newWeapon.archetype"
                                        :key="i"
                                        class="badge bg-primary d-flex align-items-center"
                                        style="
                                            font-size: 1rem;
                                            padding: 0.5em 0.75em;
                                        "
                                    >
                                        {{
                                            a.charAt(0).toUpperCase() +
                                            a.slice(1)
                                        }}
                                        <button
                                            type="button"
                                            class="btn-close btn-close-white ms-2"
                                            style="font-size: 0.6rem"
                                            @click="confirmRemoveArchetype(i)"
                                        ></button>
                                    </span>
                                </div>
                            </div>

                            <!-- Show selected abilities -->
                            <div v-if="newWeapon.abilities.length" class="mb-3">
                                <strong>Selected Abilities:</strong>
                                <div class="d-flex flex-wrap gap-2 mt-2">
                                    <span
                                        v-for="(ab, i) in newWeapon.abilities"
                                        :key="i"
                                        class="badge bg-success d-flex align-items-center"
                                        style="
                                            font-size: 1rem;
                                            padding: 0.5em 0.75em;
                                        "
                                    >
                                        {{ ab.name }}
                                        <button
                                            type="button"
                                            class="btn-close btn-close-white ms-2"
                                            style="font-size: 0.6rem"
                                            @click="confirmRemoveAbility(i)"
                                        ></button>
                                    </span>
                                </div>
                            </div>

                            ~
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button
                        type="button"
                        class="btn btn-secondary"
                        data-bs-dismiss="modal"
                    >
                        <font-awesome-icon icon="multiply" class="me-1" />Close
                    </button>
                    <button
                        type="button"
                        class="btn btn-primary"
                        @click="addWeapon()"
                    >
                        <font-awesome-icon icon="plus" class="me-1" />Add Weapon
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Modal to view a weapon -->
    <div
        class="modal fade"
        id="weaponModal"
        tabindex="-1"
        aria-labelledby="weaponModalLabel"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content bg-dark text-light rounded-3 shadow-lg">
                <div class="modal-header">
                    <h4
                        class="modal-title"
                        id="weaponModalLabel"
                        v-if="selectedWeapon"
                    >
                        {{ selectedWeapon }}
                    </h4>
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    ></button>
                </div>
                <div class="modal-body">
                    <div class="input-group mb-3">
                        <span class="input-group-text" id="weapon-type"
                            >Weapon to View</span
                        >
                        <select
                            class="form-select"
                            aria-describedby="weapon-type"
                            v-model="selectedWeapon"
                        >
                            <option
                                v-for="weapon in character.weapons || []"
                                :key="weapon.name"
                                :value="weapon.name"
                            >
                                {{ weapon.name }}
                            </option>
                        </select>
                    </div>

                    <div class="row" v-if="selectedWeapon">
                        <div
                            class="col-sm-12 d-flex justify-content-between align-items-center"
                        >
                            <h4>
                                <strong>{{
                                    currentWeapon?.name || "None"
                                }}</strong>
                            </h4>
                            <div class="d-flex justify-content-end">
                                <div
                                    v-for="(
                                        archetype, i
                                    ) in currentWeapon?.archetype || []"
                                    :key="i"
                                >
                                    <img
                                        :src="
                                            getIconSrc(
                                                archetype +
                                                    rosterStore.theme +
                                                    '.png'
                                            )
                                        "
                                        :alt="archetype"
                                        style="
                                            max-width: 2rem;
                                            margin-left: 0.5rem;
                                        "
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-12">
                            <p>{{ currentWeapon?.description }}</p>
                        </div>

                        <div class="col-sm-6">
                            <strong>Damage:</strong>
                            {{ currentWeapon?.damage || "N/A" }}
                            {{ currentWeapon?.damageType || "" }}
                        </div>

                        <div class="col-sm-6">
                            <strong>Range:</strong>
                            {{ currentWeapon?.range || "N/A" }}
                        </div>

                        <div
                            class="col-sm-12 mt-3"
                            v-if="currentWeapon?.abilities?.length > 0"
                        >
                            <strong>Abilities:</strong>
                            <ul>
                                <li
                                    v-for="(
                                        ability, i
                                    ) in currentWeapon.abilities"
                                    :key="i"
                                >
                                    <strong>{{ ability.name }}</strong
                                    >: {{ ability.description }}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button
                        type="button"
                        class="btn btn-secondary"
                        data-bs-dismiss="modal"
                    >
                        <font-awesome-icon icon="multiply" class="me-1" />Close
                    </button>
                    <button
                        type="button"
                        class="btn btn-danger"
                        @click="deleteWeapon(currentWeapon?.name)"
                        data-bs-dismiss="modal"
                    >
                        <font-awesome-icon
                            icon="trash-alt"
                            class="me-1"
                        />Remove Weapon
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapStores } from "pinia";
import { useRosterStore } from "../stores/index";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
    name: "WeaponsDisplay",
    components: { FontAwesomeIcon },
    data() {
        return {
            selectedWeapon: null, // premade dropdown selection
            activeTab: "premade", // premade | custom
            newWeapon: {
                name: "",
                description: "",
                damage: "",
                damageType: "",
                range: "",
                archetype: [],
                abilities: [], // always { name, description, [custom] }
            },
            selectedArchetype: "",
            selectedAbility: "",
            customAbilityName: "",
            customAbilityDesc: "",
        };
    },
    props: {
        character: {
            type: Object,
            required: true,
        },
    },
    computed: {
        ...mapStores(useRosterStore),

        groupedWeapons() {
            if (!this.rosterStore?.weapons) return [];

            // group by type
            const groups = this.rosterStore.weapons.reduce((acc, weapon) => {
                if (!acc[weapon.type]) acc[weapon.type] = [];
                acc[weapon.type].push(weapon);
                return acc;
            }, {});

            // sort each group by weapon name
            for (const type in groups) {
                groups[type].sort((a, b) => a.name.localeCompare(b.name));
            }

            // convert object → array and sort groups by type name
            return Object.entries(groups).sort((a, b) =>
                a[0].localeCompare(b[0])
            );
        },

        currentWeapon() {
            return this.character.weapons.find(
                (w) => w.name === this.selectedWeapon
            );
        },
        fearMod() {
            const key = (this.character.fearStatus || "")
                .toString()
                .trim()
                .toLowerCase();
            if (key === "afraid") return -1;
            if (key === "terrified") return -2;
            return 0;
        },

        abilityLookup() {
            const src = this.rosterStore?.weaponAbilities ?? [];
            const map = new Map();
            if (Array.isArray(src)) {
                src.forEach((a) => {
                    if (a?.name)
                        map.set(a.name, {
                            name: a.name,
                            description: a.description ?? "",
                        });
                });
            } else if (src && typeof src === "object") {
                Object.entries(src).forEach(([key, val]) => {
                    if (val && typeof val === "object") {
                        const name = val.name ?? key;
                        map.set(name, {
                            name,
                            description: val.description ?? "",
                        });
                    } else if (typeof val === "string") {
                        map.set(key, { name: key, description: val });
                    }
                });
            }
            return map;
        },
    },
    methods: {
        // ----- Add/Remove -----
        resetNewWeapon() {
            this.newWeapon = {
                name: "",
                description: "",
                damage: "",
                damageType: "",
                range: "",
                archetype: [],
                abilities: [],
            };
            this.selectedArchetype = "";
            this.selectedAbility = "";
            this.customAbilityName = "";
            this.customAbilityDesc = "";
        },
        getEffectiveSkill(rawSkill) {
            const stored = Math.max(0, Number(rawSkill) || 0);
            return Math.max(1, stored + this.fearMod);
        },
        requestDiceBox(statKey) {
            const skill = this.getEffectiveSkill(
                this.character.stats[statKey].skill
            );
            const talent = this.character.stats[statKey].talent;
            this.$emit("roll-dice", { skill, talent, statKey, rolltype: "skill", monsterType: null  }); // add statKey
        },
        deleteWeapon(weaponName) {
            if (!weaponName) return;
            if (confirm(`Are you sure you want to delete ${weaponName}?`)) {
                const index = this.character.weapons.findIndex(
                    (w) => w.name === weaponName
                );
                if (index !== -1) {
                    this.character.weapons.splice(index, 1);
                }
                this.selectedWeapon = null;
            }
        },

        // ----- Premade weapons -----
        fillFromPreset() {
            if (!this.selectedWeapon) {
                this.resetNewWeapon();
                return;
            }
            const preset = this.rosterStore.weapons.find(
                (w) => w.name === this.selectedWeapon
            );
            if (preset) {
                this.newWeapon = {
                    ...preset,
                    archetype: Array.isArray(preset.archetype)
                        ? [...preset.archetype]
                        : [],
                    abilities: Array.isArray(preset.abilities)
                        ? preset.abilities.map((a) => {
                              if (typeof a === "string") {
                                  const storeAb = this.abilityLookup.get(a);
                                  return {
                                      name: a,
                                      description:
                                          storeAb?.description ||
                                          "No description available.",
                                  };
                              }
                              return { ...a };
                          })
                        : [],
                };
            }
        },

        // ----- Add weapon (handles premade/custom) -----
        ensureUniqueAbilityName(name) {
            let newName = name;
            let counter = 65; // ASCII A
            while (
                this.rosterStore.weaponAbilities.some((a) => a.name === newName)
            ) {
                newName = `${name} (${String.fromCharCode(counter)})`;
                counter++;
            }
            return newName;
        },
        addWeapon(source = "custom") {
            if (!this.newWeapon.name) {
                alert("Weapon must have a name!");
                return;
            }

            if (!this.newWeapon.damage) {
                alert("Weapon must have damage value!");
                return;
            }

            if (!this.newWeapon.damageType) {
                alert("Weapon must have damage type!");
                return;
            }

            if (!this.newWeapon.range) {
                alert("Weapon must have a range!");
                return;
            }

            // must have at least one skill type
            if (!this.newWeapon.archetype.length) {
                alert("Weapon must have at least one Skill Type!");
                return;
            }

            // check for unadded custom ability
            if (
                this.customAbilityName.trim() ||
                this.customAbilityDesc.trim()
            ) {
                alert(
                    "You have entered a custom ability but not added it. Please click 'Add' to include it."
                );
                return;
            }

            if (this.selectedAbility !== "") {
                alert(
                    "You have selected an ability but not added it. Please click 'Add' to include it."
                );
                return;
            }

            // Normalize copy
            const weaponToAdd = {
                ...this.newWeapon,
                archetype: [...this.newWeapon.archetype],
                abilities: this.newWeapon.abilities.map((a) => ({ ...a })),
            };

            // Always push to character
            this.character.weapons.push(weaponToAdd);

            // Push to compendium only for custom tab
            if (source === "custom") {
                if (
                    !this.rosterStore.weapons.find(
                        (w) => w.name === weaponToAdd.name
                    )
                ) {
                    this.rosterStore.weapons.push(weaponToAdd);
                }

                // custom abilities only
                for (const ability of weaponToAdd.abilities) {
                    if (ability.custom) {
                        const uniqueName = this.ensureUniqueAbilityName(
                            ability.name
                        );
                        const abilityToAdd = { ...ability, name: uniqueName };
                        delete abilityToAdd.custom;
                        this.rosterStore.weaponAbilities.push(abilityToAdd);
                    }
                }
            }

            this.selectedWeapon = null;
            this.resetNewWeapon();
            alert("Weapon added!");
        },

        // ----- Archetypes -----
        addArchetype() {
            if (
                this.selectedArchetype &&
                !this.newWeapon.archetype.includes(this.selectedArchetype)
            ) {
                this.newWeapon.archetype.push(
                    this.selectedArchetype.toLowerCase()
                );
            }
            this.selectedArchetype = "";
        },
        confirmRemoveArchetype(index) {
            const type = this.newWeapon.archetype[index];
            if (confirm(`Remove skill type "${type}"?`)) {
                this.newWeapon.archetype.splice(index, 1);
            }
        },

        // ----- Abilities -----
        addAbility() {
            if (!this.selectedAbility) return;
            if (
                !this.newWeapon.abilities.find(
                    (a) => a.name === this.selectedAbility
                )
            ) {
                const storeAb = this.abilityLookup.get(this.selectedAbility);
                this.newWeapon.abilities.push({
                    name: this.selectedAbility,
                    description:
                        storeAb?.description || "No description available.",
                    custom: false,
                });
            }
            this.selectedAbility = "";
        },
        addCustomAbility() {
            const name = this.customAbilityName.trim();
            const desc = this.customAbilityDesc.trim();

            if (!name || !desc) {
                alert(
                    "Custom abilities must have both a Name and a Description!"
                );
                return;
            }

            this.newWeapon.abilities.push({
                name,
                description: desc,
                custom: true, // mark for pushing to store
            });

            this.customAbilityName = "";
            this.customAbilityDesc = "";
        },
        confirmRemoveAbility(index) {
            const ab = this.newWeapon.abilities[index];
            if (confirm(`Remove ability "${ab.name}"?`)) {
                this.newWeapon.abilities.splice(index, 1);
            }
        },

        // ----- Assets -----
        getIconSrc(filename) {
            try {
                return require(`@/../public/img/${filename}`);
            } catch (e) {
                console.warn(`Icon not found: ${filename}`);
                return;
            }
        },
    },
};
</script>

<style scoped>
.weapons-display {
    padding: 10px 5px;
    border: solid 2px #555;
    border-radius: 8px;
}
</style>

